import styled from "styled-components";


export const DescriptionStyle = styled.div<{ $color?: string; $align?: string; $marginBottom?: string; $marginTop?: string; $size?: string }>`
  font-size: ${({ $size }) => $size || '18px'};  
  font-family: 'Inter', Arial, sans-serif;
  color: ${({ $color }) => $color || '#fff'}; 
  text-align: ${({ $align }) => $align || 'left'};
  margin-bottom: ${({ $marginBottom }) => $marginBottom || '0px'};
  margin-top: ${({ $marginTop }) => $marginTop || '0px'};
`;